import { createContext, useContext } from "react";

// Which page is being rendered. Section links ("#contacto") only resolve on
// the home page; elsewhere they point back to it ("/#nosotros").
export const RouteContext = createContext({ path: "/", isHome: true, localSections: [] });

export function useRoute() {
  return useContext(RouteContext);
}

export function useSectionHref() {
  const { isHome, localSections = [] } = useRoute();
  return (id) => (isHome || localSections.includes(id) ? `#${id}` : `/#${id}`);
}
